import { css } from '@mui/material';

export const useStyles = () => {
  return {
    cardConatiner: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      border-radius: 20px;
      padding: 16px;
      box-shadow: 0px 0px 20px 0px #0000000d;
    `,

    cardTextConatiner: css`
      display: flex;
      align-items: center;
      gap: 6px;
      max-width: 154px;

      svg {
        flex-shrink: 0;
      }
    `,

    tooltip: css`
        
    `,

    tooltipIcon: css`
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-left: 8px;
      color: #6d6d6d;
      cursor: pointer;
    `,
  };
};
